var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92505 16.5762C12.8601 16.5762 16.0501 13.3862 16.0501 9.45117C16.0501 5.51614 12.8601 2.32617 8.92505 2.32617C4.99002 2.32617 1.80005 5.51614 1.80005 9.45117C1.80005 13.3862 4.99002 16.5762 8.92505 16.5762Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80005 9.45117H16.0501",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92507 2.32617C10.7072 4.27725 11.72 6.80925 11.7751 9.45117C11.72 12.0931 10.7072 14.6251 8.92507 16.5762C7.14291 14.6251 6.13011 12.0931 6.07507 9.45117C6.13011 6.80925 7.14291 4.27725 8.92507 2.32617V2.32617Z",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWorld);
export default __webpack_public_path__ + "static/media/ic_world.761cc6d45989aeb5fec2549d307c274b.svg";
export { ForwardRef as ReactComponent };